export default __webpack_public_path__ + "static/media/password.0749cb6c.svg";